import { render, staticRenderFns } from "./Publishing.vue?vue&type=template&id=37e295e6&scoped=true&"
import script from "./Publishing.vue?vue&type=script&lang=js&"
export * from "./Publishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e295e6",
  null
  
)

export default component.exports